import { render, staticRenderFns } from "./mo-formfield-decorator.html?vue&type=template&id=01942680&scoped=true&external"
import script from "./mo-formfield-decorator.ts?vue&type=script&lang=ts&external"
export * from "./mo-formfield-decorator.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-formfield-decorator.scss?vue&type=style&index=0&id=01942680&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01942680",
  null
  
)

export default component.exports